/**
 * GlobalSmsDialog — listens for 'crm-open-sms' CustomEvent (dispatched by
 * RowContextMenu's "Odeslat SMS" action) and opens the SendSmsDialog.
 *
 * Mount once in App.js so any context menu in the tree can request an SMS dialog.
 */
import React, { useEffect, useState } from "react";
import { SendSmsDialog } from "./SendSmsButton";

export default function GlobalSmsDialog() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      if (!detail.module || !detail.entityId) return;
      setConfig({
        module: detail.module,
        entityId: detail.entityId,
        defaultRecipients: detail.recipients || [],
      });
    };
    window.addEventListener("crm-open-sms", handler);
    return () => window.removeEventListener("crm-open-sms", handler);
  }, []);

  if (!config) return <div data-testid="global-sms-dialog-mounted" style={{ display: "none" }} />;
  return (
    <>
      <div data-testid="global-sms-dialog-mounted" style={{ display: "none" }} />
      <SendSmsDialog
        module={config.module}
        entityId={config.entityId}
        defaultRecipients={config.defaultRecipients}
        onClose={() => setConfig(null)}
      />
    </>
  );
}
